import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import RatingInputService from '../services/rating-input-service.js';

window.dataLayer = window.dataLayer || [];

class ReviewInvite {
	constructor() {
		this.ratingInputService = new RatingInputService();
		this.ratingInputService.setupInputListener();
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new ReviewInvite();
});